import React from 'react';

const InputField = ({ 
  label, 
  type = "text", 
  value, 
  onChange, 
  placeholder,
  name,
  required = false,
  disabled = false,
  className = ""
}) => {
  return (
    <label className="flex flex-col">
      {label && (
        <p className="text-[#111418] dark:text-gray-100 text-base font-medium leading-normal pb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </p>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] dark:text-gray-100 focus:outline-0 focus:ring-2 focus:ring-primary/50 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 h-14 placeholder:text-gray-400 p-[15px] text-base font-normal leading-normal ${className}`}
      />
    </label>
  );
};

export default InputField;
